import React from 'react';
import { inRange, isEmpty } from 'lodash';
import { Container } from '@fiverr-private/layout_components';
import { Box } from '@fiverr-private/theme';
import { Text } from '@fiverr-private/typography';
import { numberFormat } from '@fiverr-private/localization';
import RatingStar from './RatingStar';
import { formatStars } from './utils';
import { MIN_RATING, MAX_RATING } from './constants';
import { RatingProps } from './types';

const Rating = ({
  score,
  minimumFractionDigits,
  maximumFractionDigits,
  showScore = true,
  reviews,
  variant = 'full',
  onReviewsClick,
}: RatingProps) => {
  if (!inRange(score, MIN_RATING, MAX_RATING)) {
    return null;
  }

  const isReviewsClickable = typeof onReviewsClick === 'function';
  const stars = formatStars(variant, score);

  return (
    <Box display="flex" alignItems="center">
      <Container display="inlineFlex" paddingBottom="1">
        {stars.map((starVariant, index) => (
          <Container key={index} as="span" paddingLeft={index !== 0 ? '1' : undefined} display="inlineFlex">
            <RatingStar starVariant={starVariant} />
          </Container>
        ))}
      </Container>
      {showScore && (
        <Text as="strong" fontWeight="bold" paddingLeft="1">
          {numberFormat({
            value: score,
            options: {
              fallbackValue: score,
              minimumFractionDigits,
              maximumFractionDigits,
            },
          })}
        </Text>
      )}
      {!isEmpty(reviews) && (
        <Box
          as={isReviewsClickable ? 'button' : 'span'}
          marginLeft="1"
          onClick={onReviewsClick}
          color="bodySecondary"
          borderRadius="sm"
          outlineOffset={{
            focusVisible: 'sm',
          }}
          outlineWidth={{
            focusVisible: 'md',
          }}
          outlineStyle={{ focusVisible: 'solid' }}
          outlineColor={{
            focusVisible: 'grey_1200',
          }}
        >
          (
          <Text
            as="span"
            color="inherit"
            {...(isReviewsClickable ? { decoration: 'underline', cursor: 'pointer' } : {})}
          >
            {reviews}
          </Text>
          )
        </Box>
      )}
    </Box>
  );
};

Rating.displayName = 'Rating';
export default Rating;
